<template>
  <!-- 2026-10-15：共用帮助弹窗默认图文，切出视频或关闭时卸载播放器，避免后台继续播放。 -->
  <a-modal :visible="visible" :title="title + ' · 帮助'" :footer="null" :width="860" :destroyOnClose="true" @cancel="$emit('close')">
    <a-tabs v-if="visible" v-model:activeKey="activeTab">
      <a-tab-pane key="text" tab="图文">
        <section class="function-help-text" aria-label="图文帮助">
          <h2>{{ title }}</h2>
          <p>{{ description || '暂无图文说明。' }}</p>
        </section>
      </a-tab-pane>
      <a-tab-pane key="video" tab="视频">
        <div v-if="activeTab === 'video' && safeUrl" class="function-help-video">
          <video :key="safeUrl" :src="safeUrl" controls playsinline preload="metadata" @error="failed = true" @loadeddata="failed = false"></video>
          <p v-if="failed" role="alert">视频暂时无法播放，请检查网络或联系管理员核对视频地址。</p>
        </div>
        <a-empty v-else-if="activeTab === 'video'" description="暂无帮助视频，可先查看图文说明。" />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script lang="ts">
// 2026-10-15：每次打开帮助先展示图文；说明以文本渲染，视频沿用已有安全地址校验。
import { computed, defineComponent, ref, watch } from 'vue'
import { safeFunctionVideoUrl } from '@/utils/functionGuides'
export default defineComponent({
  props: {
    visible: Boolean, url: { type: String, default: '' }, title: { type: String, default: '' },
    description: { type: String, default: '' }
  },
  emits: ['close'],
  setup(props) {
    const activeTab = ref('text'), failed = ref(false)
    const safeUrl = computed(() => safeFunctionVideoUrl(props.url))
    watch(() => props.visible, () => { activeTab.value = 'text'; failed.value = false }, { flush: 'sync' })
    watch(() => [props.url, activeTab.value], () => { failed.value = false }, { flush: 'sync' })
    return { activeTab, failed, safeUrl }
  }
})
</script>
<style scoped>
/* 2026-10-15：图文内容保留换行并独立滚动，帮助弹窗和视频适应窄屏及横竖比例。 */
.function-help-text { min-height:180px; max-height:60vh; overflow:auto; padding:20px; border:1px solid #e8e8e8; border-radius:6px; background:#fafafa; }
.function-help-text h2 { margin:0 0 16px; font-size:18px; overflow-wrap:anywhere; }
.function-help-text p { margin:0; white-space:pre-wrap; overflow-wrap:anywhere; line-height:1.8; }
.function-help-video video { display:block; width:100%; max-height:60vh; background:#000; }
.function-help-video p { color:#cf1322; margin:12px 0 0; }
</style>
